import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function countUp() {

    const items = document.querySelectorAll('[data-countup]');

    items.forEach(item => {

        const rawValue = item.getAttribute('data-countup');
        const numberEl = item.querySelector('.figures__number');

        if (!numberEl) return;

        // Extract the numeric portion (supports decimals)
        const numericMatch = rawValue.match(/[\d.]+/);

        if (!numericMatch) {
            numberEl.textContent = rawValue;
            return;
        }

        const target = parseFloat(numericMatch[0]);
        const isDecimal = !Number.isInteger(target);

        // Preserve any prefix / suffix around the number (e.g. "+", "%")
        const numStart = rawValue.indexOf(numericMatch[0]);
        const prefix = rawValue.slice(0, numStart);
        const suffix = rawValue.slice(numStart + numericMatch[0].length);

        const obj = { value: 0 };

        gsap.to(obj, {
            value: target,
            duration: 2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: item,
                start: "top 80%",
                once: true,
            },
            onUpdate() {
                const display = isDecimal
                    ? obj.value.toFixed(1)
                    : Math.round(obj.value);
                numberEl.textContent = prefix + display + suffix;
            },
            onComplete() {
                numberEl.textContent = prefix + (isDecimal ? target.toFixed(1) : target) + suffix;
            },
        });

    });

}

export default countUp;
